import $ from 'jquery';

export default function Room(vm) {
    this.all = function(params) {
        var url = '/room/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/room/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/room/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/room/force-delete/' + params.id;
        else
            url = '/room/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/room/restore/' + id;

        return vm.get(url);
    };
}